import EmptyChartIcon from './EmptyChartIcon';
import { EmptyStateWrapper } from './styled';

const EmptyChart = () => (
  <EmptyStateWrapper>
    <div className="no-data">
      <EmptyChartIcon />

      <div className="margin-top-18 text-empty-state">
        Data Chart Belum Tersedia
      </div>
    </div>
  </EmptyStateWrapper>
);

export default EmptyChart;
